export default __webpack_public_path__ + "static/media/hht2_ep19_timeline_02_blank.189b8df0.png";